// extracted by mini-css-extract-plugin
export default {"main":"Label--main--1-9i-"};